import { AxiosInstance } from "axios";

export default (httpClient: AxiosInstance) => ({
    Listar: async (pIdPaciente: number) => {
        const response = await httpClient.get(`/Paciente/convenioListar?pIdPaciente=${pIdPaciente}`);

        let erros = null;
        if (!response.data) {
            erros = {
                status: response.request.status,
                statusText: response.request.statusText
            };
        }
        return {
            data: response.data,
            erros: erros
        };
    },
    Existe: async (pIdPaciente: number, pIdConvenio: number) => {
        const response = await httpClient.get(`/Paciente/existeConv?pIdPaciente=${pIdPaciente}&pIdConvenio=${pIdConvenio}`);

        let erros = null;
        if (!response.data) {
            erros = {
                status: response.request.status,
                statusText: response.request.statusText
            };
        }
        return {
            data: response.data,
            erros: erros
        };
    },
    Inserir: async (pIdPaciente: number, pIdConvenio: number, pDtValidade: string, pMatricula: string) => {
        const response = await httpClient.post(`/Paciente/convenioInserir?pIdPaciente=${pIdPaciente}&pIdConvenio=${pIdConvenio}&pDtValidade=${pDtValidade}&pMatricula=${pMatricula}`);
        //10/10/2030
        let erros = null;
        if (!response.data) {
            erros = {
                status: response.request.status,
                statusText: response.request.statusText
            };
        }
        return {
            data: response.data,
            erros: erros
        };
    },
    Alterar: async (pIdPaciente: number, pIdConvenio: number, pDtValidade: string, pMatricula: string) => {
        const response = await httpClient.post(`/Paciente/convenioAlterar?pIdPaciente=${pIdPaciente}&pIdConvenio=${pIdConvenio}&pDtValidade=${pDtValidade}&pMatricula=${pMatricula}`);

        let erros = null;
        if (!response.data) {
            erros = {
                status: response.request.status,
                statusText: response.request.statusText
            };
        }
        return {
            data: response.data,
            erros: erros
        };
    },
    Excluir: async (pIdPaciente: number, pIdConvenio: number) => {
        const response = await httpClient.post(`/Paciente/convenioExcluir?pIdPaciente=${pIdPaciente}&pIdConvenio=${pIdConvenio}`);

        let erros = null;
        if (!response.data) {
            erros = {
                status: response.request.status,
                statusText: response.request.statusText
            };
        }
        return {
            data: response.data,
            erros: erros
        };
    }

});